import {useEffect,useRef} from 'react';
import { useDispatch } from 'react-redux';
import BasePage from '../common/base';
import { CartContainer } from './cart.container';
import { BasePageStyles } from '../../hooks/styles';
import { Container } from '@mui/material';

const Cart = () => {
  const classes = BasePageStyles();
  const isFirstRender = useRef(true)
  const dispatch = useDispatch();
  
  useEffect(() => {
    isFirstRender.current = false
  }, [dispatch])

  return (
    <BasePage>
      <div className={classes.appBarSpacer}></div>
      <Container maxWidth={false} className={classes.container}>
        <CartContainer />
      </Container>
    </BasePage>
  )
}

export default Cart;  